export interface IFilterClause {
  operator: string;
}

export interface ILeafFilterClause extends IFilterClause {
}

export interface ICompositeFilterClause extends IFilterClause {
  clauses: ILeafFilterClause[];
}

export interface IStringValuedFilterClause extends ILeafFilterClause {
  value: string;
}

export interface IFieldFilterClause extends ILeafFilterClause {
  field: string;
}

export interface IValuedFieldFilterClause<T> extends IFieldFilterClause {
  value: T;
}

export type IStringValuedFieldFilterClause = IStringValuedFilterClause & IFieldFilterClause;

export interface IStringArrayValuedFieldFilterClause<T extends string = string> extends IFieldFilterClause {
  values: ReadonlyArray<T>;
}

export const FilterOps = {
  and:      'and',
  eq:       'eq',
  lte:      'lte',
  gte:      'gte',
  has:      'has',
  inArray:  'in',
  matches:  'matches'
};

/**
 * These are the server-side filter names, which are sent to various backend APIs. They are converted
 * from the client-side filters in ServerFilterClauses.ts.
 */
export const FilterFieldNames = {
  isCertified:          'isCertified',
  collectionVisibility: 'visibility',
  completedAt:          'completedAt',
  connectionType:       'connectionType',
  containerType:        'containerType',
  contentType:          'contentType',
  createdAt:            'createdAt',
  databaseUsername:     'databaseUsername',
  datasourceId:         'datasourceId',
  domainId:             'domainId',
  domainName:           'domainName',
  extractStatus:        'extractStatus',
  workbookConnFilter:   'workbookConnFilter',
  flowId:               'flowId',
  flowOutputStepName:   'flowOutputStepName',
  groupId:              'groupId',
  groupIds:             'groupIds',
  hasActiveWarning:     'hasActiveWarning',
  hasAlert:             'hasAlert',
  hasExtracts:          'hasExtracts',
  hasEmbeddedPassword:  'hasEmbeddedPassword',
  includeLiveToDataEngine: 'includeLiveToDataEngine',
  isDefaultPort:        'isDefaultPort',
  isFavorite:           'isFavorite',
  isPublished:          'isPublished',
  isRecent:             'isRecent',
  lastRefreshedAt:      'lastRefreshedAt',
  maxSiteRole:          'maxSiteRole',
  minimumSiteRole:      'minimumSiteRole',
  ownerId:              'ownerId',
  ownerUserName:        'ownerUserName',
  parentId:             'parentId',
  parentType:           'parentType',
  parentProjectId:      'parentProjectId',
  projectId:            'projectId',
  scheduledAction:      'scheduledAction',
  scheduleId:           'scheduleId',
  serverName:           'serverName',
  serverPort:           'serverPort',
  siteId:               'siteId',
  showSystemJobs:       'showSystemJobs',
  siteRole:             'siteRole',
  startedAt:            'startedAt',
  status:               'status',
  taskType:             'taskType',
  tags:                 'tags',
  timeRange:            'timeRange',
  topLevelProject:      'topLevelProject',
  updatedAt:            'updatedAt',
  userId:               'userId',
  urlName:              'repositoryUrl',
  workbookId:           'workbookId',
  dataAccelerationStatus: 'dataAccelerationStatus',
};
